import React from "react";
import PropTypes from "prop-types";
import LanguageSelector from "common/LanguageSelector";
import CandidatePageWrapper from "candidate/CandidatePageWrapper";
import ConfidentialityLock from "candidate/ConfidentialityLock";

function HubPageWrapper({ legalText, companyName, children }) {
    return (
        <CandidatePageWrapper contentClassName="hub">
            <header className="check-in__header">
                <div className="check-in__header-left">
                    <ConfidentialityLock legalText={legalText} companyName={companyName} />
                </div>
            </header>
            {children}
            <LanguageSelector />
        </CandidatePageWrapper>
    );
}

HubPageWrapper.propTypes = {
    legalText: PropTypes.string,
    companyName: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

HubPageWrapper.defaultProps = {
    legalText: null,
    companyName: "",
};

export default React.memo(HubPageWrapper);
